<template>
  <div class="row">
    <div class="col-md-12">
      <ValidationObserver v-slot="{ invalid }">
        <card>
          <h5 slot="header" class="title">
            {{ $t('editDefaultMonitor.cardTitle') }} — {{ techLabel }}
          </h5>

          <div class="row">
            <div class="col-md-3">
              <label class="control-label">{{ $t('editDefaultMonitor.technology') }}</label>
              <div class="form-group">
                <input class="form-control" :value="techLabel" disabled>
              </div>
            </div>

            <div class="col-md-3">
              <label class="control-label">{{ $t('editDefaultMonitor.enabled') }}</label>
              <div class="form-group" style="height: calc(2.249999625rem + 2px); display: flex; align-items: center;">
                <input type="checkbox" v-model="model.enabled" style="width: 20px; height: 20px; cursor: pointer;">
              </div>
            </div>

          </div>

          <div class="row">
            <ValidationProvider rules="required|double|between:1.50,3" v-slot="{ validate, errors }" slim>
              <div class="col-md-4">
                <div>
                  <label class="control-label">{{ $t('editMonitor.cellsUndervoltageThreshold') }}</label>
                </div>
                <div class="row">
                  <div class="col-md-3" style="margin-right: -15px;">
                    <div class="form-group" style="margin: 0px;">
                      <input
                        v-bind:class="errors[0] ? 'form-control input-error' : 'form-control'"
                        v-model="model.elemVmin"
                        @change="validate">
                    </div>
                  </div>
                  <div class="col-md-9">
                    <div class="form-group" style="margin: 0px;">
                      <input
                        v-bind:class="errors[0] ? 'form-control custom-range input-error' : 'form-control custom-range'"
                        type="range" min="1.50" max="3" step=".01"
                        v-model="model.elemVmin">
                    </div>
                  </div>
                </div>
                <label class="input-error">{{ errors[0] }}</label>
              </div>
            </ValidationProvider>

            <ValidationProvider rules="required|double|between:1.50,5" v-slot="{ validate, errors }" slim>
              <div class="col-md-4">
                <div>
                  <label class="control-label">{{ $t('editMonitor.minCellsChargingVoltage') }}</label>
                </div>
                <div class="row">
                  <div class="col-md-3" style="margin-right: -15px;">
                    <div class="form-group" style="margin: 0px;">
                      <input
                        v-bind:class="errors[0] ? 'form-control input-error' : 'form-control'"
                        v-model="model.elemVmcv"
                        @change="validate">
                    </div>
                  </div>
                  <div class="col-md-9">
                    <div class="form-group" style="margin: 0px;">
                      <input
                        v-bind:class="errors[0] ? 'form-control custom-range input-error' : 'form-control custom-range'"
                        type="range" min="1.50" max="5" step=".01"
                        v-model="model.elemVmcv">
                    </div>
                  </div>
                </div>
                <label class="input-error">{{ errors[0] }}</label>
              </div>
            </ValidationProvider>

            <ValidationProvider rules="required|integer|between:0,480" v-slot="{ validate, errors }" slim>
              <div class="col-md-4">
                <div>
                  <label class="control-label">{{ $t('editMonitor.minChargingTime') }}</label>
                </div>
                <div class="row">
                  <div class="col-md-3" style="margin-right: -15px;">
                    <div class="form-group" style="margin: 0px;">
                      <input
                        v-bind:class="errors[0] ? 'form-control input-error' : 'form-control'"
                        v-model="model.minDuration"
                        @change="validate">
                    </div>
                  </div>
                  <div class="col-md-9">
                    <div class="form-group" style="margin: 0px;">
                      <input
                        v-bind:class="errors[0] ? 'form-control custom-range input-error' : 'form-control custom-range'"
                        type="range" min="0" max="480" step="1"
                        v-model="model.minDuration">
                    </div>
                  </div>
                </div>
                <label class="input-error">{{ errors[0] }}</label>
              </div>
            </ValidationProvider>
          </div>

          <div class="row">
            <ValidationProvider rules="required|integer|between:-40,20" v-slot="{ validate, errors }" slim>
              <div class="col-md-4">
                <div>
                  <label class="control-label">{{ $t('editMonitor.minTemp') }}</label>
                </div>
                <div class="row">
                  <div class="col-md-3" style="margin-right: -15px;">
                    <div class="form-group" style="margin: 0px;">
                      <input
                        v-bind:class="errors[0] ? 'form-control input-error' : 'form-control'"
                        v-model="model.Tmin"
                        @change="validate">
                    </div>
                  </div>
                  <div class="col-md-9">
                    <div class="form-group" style="margin: 0px;">
                      <input
                        v-bind:class="errors[0] ? 'form-control custom-range input-error' : 'form-control custom-range'"
                        type="range" min="-40" max="20" step="1"
                        v-model="model.Tmin">
                    </div>
                  </div>
                </div>
                <label class="input-error">{{ errors[0] }}</label>
              </div>
            </ValidationProvider>

            <ValidationProvider rules="required|integer|between:20,200" v-slot="{ validate, errors }" slim>
              <div class="col-md-4">
                <div>
                  <label class="control-label">{{ $t('editMonitor.maxTemp') }}</label>
                </div>
                <div class="row">
                  <div class="col-md-3" style="margin-right: -15px;">
                    <div class="form-group" style="margin: 0px;">
                      <input
                        v-bind:class="errors[0] ? 'form-control input-error' : 'form-control'"
                        v-model="model.Tmax"
                        @change="validate">
                    </div>
                  </div>
                  <div class="col-md-9">
                    <div class="form-group" style="margin: 0px;">
                      <input
                        v-bind:class="errors[0] ? 'form-control custom-range input-error' : 'form-control custom-range'"
                        type="range" min="20" max="200" step="1"
                        v-model="model.Tmax">
                    </div>
                  </div>
                </div>
                <label class="input-error">{{ errors[0] }}</label>
              </div>
            </ValidationProvider>

            <ValidationProvider rules="required|integer|between:1,20" v-slot="{ validate, errors }" slim>
              <div class="col-md-2">
                <div>
                  <label class="control-label">{{ $t('editMonitor.numCycles') }}</label>
                </div>
                <div class="row">
                  <div class="col-md-6" style="margin-right: -15px;">
                    <div class="form-group" style="margin: 0px;">
                      <input
                        v-bind:class="errors[0] ? 'form-control input-error' : 'form-control'"
                        v-model="model.numCycles"
                        @change="validate">
                    </div>
                  </div>
                </div>
                <label class="input-error">{{ errors[0] }}</label>
              </div>
            </ValidationProvider>
          </div>

          <div class="button-row">
            <div class="button-container">
              <base-button slot="footer" type="primary-nogradient" @click="saveDefaultMonitor()" fill :disabled="invalid">
                {{ $t('editDefaultMonitor.saveButton') }}
              </base-button>
            </div>
            <div class="button-container">
              <base-button slot="footer" type="danger-nogradient" @click="cancel()" fill>
                {{ $t('editDefaultMonitor.backButton') }}
              </base-button>
            </div>
          </div>
        </card>
      </ValidationObserver>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, integer, double, between } from 'vee-validate/dist/rules';
import { batteryTechEnum } from '@/config/env'

export default {
  components: { ValidationProvider, ValidationObserver },
  data() {
    return {
      techBatt: null,
      model: {
        enabled: false,
        elemVmin: 1.65,
        elemVmcv: 2.40,
        minDuration: 240,
        Tmin: -10,
        Tmax: 60,
        numCycles: 1,
      },
      batteryTechEnum
    }
  },
  computed: {
    techLabel() {
      return this.techBatt !== null ? (this.batteryTechEnum[this.techBatt] || String(this.techBatt)) : ''
    },
    locale() {
      return this.$i18n.locale
    },
    ...mapState(['monitors', 'isAdmin'])
  },
  watch: {
    locale() {
      this.localizeValidationErrorMessages()
    }
  },
  mounted() {
    const tech = localStorage.getItem('selectedDefaultMonitorTech')
    if (tech !== null) {
      this.techBatt = JSON.parse(tech)
      const existing = this.monitors.find(m => m.isDefault && Number(m.techBatt) === Number(this.techBatt))
      if (existing) {
        this.model.enabled = !!existing.enabled
        this.model.elemVmin = existing.elemVmin
        this.model.elemVmcv = existing.elemVmcv
        this.model.minDuration = existing.minDuration
        this.model.Tmin = existing.Tmin
        this.model.Tmax = existing.Tmax
        this.model.numCycles = existing.numCycles
      }
    } else {
      this.$router.push('default-monitors-panel')
    }
    this.localizeValidationErrorMessages()
  },
  methods: {
    localizeValidationErrorMessages() {
      extend('required', { ...required, message: this.$t('validationErrorMessages.required') });
      extend('integer', { ...integer, message: this.$t('validationErrorMessages.integer') });
      extend('double', { ...double, message: this.$t('validationErrorMessages.double') });
      extend('between', { ...between, params: ['min', 'max'], message: this.$t('validationErrorMessages.between') });
    },
    saveDefaultMonitor() {
      const payload = {
        ...this.model,
        techBatt: this.techBatt,
        isDefault: true,
      }
      this.axios.post('https://4wq3fnef63.execute-api.eu-central-1.amazonaws.com/default/listMonitors', payload)
        .then(() => {
          this.$store.dispatch('updateMonitors')
          this.$router.push('default-monitors-panel')
        })
        .catch(error => {
          console.log("Error saving default monitor")
          console.log(error)
          this.$router.push('default-monitors-panel')
        })
    },
    cancel() {
      this.$router.push('default-monitors-panel')
    }
  }
}
</script>
